import React from 'react'
import { WorkForceHeroSection } from '../components/sections/workforce/WorkForceHeroSection'
import { WorkForceFeatures } from '../components/sections/workforce/WorkForceFeatures'
import { PlatformIntegration } from '../components/sections/workforce/PlatformIntegration'
import { IndustryShowcase } from '../components/sections/workforce/IndustryShowcase'
import { TechArchitecture } from '../components/sections/workforce/TechArchitecture'

export const WorkForcePage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <WorkForceHeroSection />
      <WorkForceFeatures />
      <PlatformIntegration />
      <IndustryShowcase />
      <TechArchitecture />
    </div>
  )
}